import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useAsyncProcess } from 'hooks/useAsyncProcess';

export const usePartnerPaidClientTableGroups = () => {
  const runAsyncProcess = useAsyncProcess();

  const dispatch = useAppDispatcher();

  const {
    partnerDashboard: {
      paidClientGroupsInvalidated,
      paidClientGroups: partnerPaidClientTableGroups,
    },
  } = useAppState();

  React.useLayoutEffect(() => {
    if (paidClientGroupsInvalidated) {
      runAsyncProcess((services) =>
        services.getPartnerPaidClientTableGroupsService().then((groups) => {
          dispatch({
            name: 'PartnerClientsPage__PaidClientsTableGroupsRecieved',
            groups,
          });
        })
      );
    }
  }, [dispatch, runAsyncProcess, paidClientGroupsInvalidated]);

  return {
    partnerPaidClientTableGroups,
  };
};
